// utils/toast.js
import React, { lazy } from "react";
import { toast as baseToast } from "react-toastify";
import "./toast.css";

export const toast = baseToast;

export const LazyToastContainer = lazy(() =>
  import("react-toastify").then((m) => ({ default: m.ToastContainer }))
);

export const toaster = (type, message, dir = "ltr", options = {}) => {
  const position = dir === "rtl" ? "top-left" : "top-right";

  // default style per type
  let icon;
  let style = {};

  switch (type) {
    case "success":
      icon = React.createElement("img", {
        src: "/StatusIcons/checkmarkIcon.svg",
        alt: "checked",
        style: { width: 20, height: 20 },
      });
      style = { backgroundColor: "#d1decc", color: "#093725" };
      break;
    case "info":
      icon = true; // use default icon
      style = { backgroundColor: "#003e29", color: "#FFFFFF" };
      break;
    case "error":
      icon = true; // default icon
      style = { backgroundColor: "#f8dcdb", color: "#b81320" };
      break;
    case "warn":
    case "warning":
      icon = React.createElement("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 24 24",
        fill: "#FFD100", // triangle fill
        stroke: "#000000", // triangle border
        strokeWidth: 1,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
          React.createElement("path", {
            d: "M1 21h22L12 2 1 21z", // triangle
          }),
          React.createElement("rect", {
            x: 11.5, // vertical stick center
            y: 8, // top of stick
            width: 1, // thickness of stick
            height: 6, // stick height
            fill: "#000000",
          }),
          React.createElement("circle", {
            cx: 12, // center horizontally
            cy: 18, // dot vertical position
            r: 1, // dot radius
            fill: "#000000",
          }),
        ],
      });
      style = { backgroundColor: "#FFD100", color: "#060600" };
      break;
    default:
      icon = true;
      style = {};
  }

  const config = {
    position,
    icon,
    style,
    ...options,
  };

  switch (type) {
    case "success":
      toast.success(message, config);
      break;
    case "error":
      toast.error(message, config);
      break;
    case "info":
      toast.info(message, config);
      break;
    case "warn":
    case "warning":
      toast.warning(message, config);
      break;
    default:
      toast(message, config);
  }
};
